/** Brown line-art icons on warm tiles (Coconut Telegraph form reference). */
const stroke = "#6b4423";

function SvgFrame({ children }: { children: React.ReactNode }) {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
      {children}
    </svg>
  );
}

export function IconRegistrationType() {
  return (
    <SvgFrame>
      <path
        d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z"
        stroke={stroke}
        strokeWidth="1.65"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgFrame>
  );
}

export function IconConcept() {
  return (
    <SvgFrame>
      <path
        d="M12 3c-2 3-6 4-6 9a6 6 0 1 0 12 0c0-5-4-6-6-9z"
        stroke={stroke}
        strokeWidth="1.65"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M12 14v4" stroke={stroke} strokeWidth="1.65" strokeLinecap="round" />
    </SvgFrame>
  );
}

export function IconLocation() {
  return (
    <SvgFrame>
      <path
        d="M12 21s7-4.35 7-10a7 7 0 1 0-14 0c0 5.65 7 10 7 10z"
        stroke={stroke}
        strokeWidth="1.65"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="12" cy="11" r="2.2" stroke={stroke} strokeWidth="1.65" />
    </SvgFrame>
  );
}

export function IconRole() {
  return (
    <SvgFrame>
      <path
        d="M12 3l8 4v6c0 5-3.5 9-8 11-4.5-2-8-6-8-11V7l8-4z"
        stroke={stroke}
        strokeWidth="1.65"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M9 12h6M12 9v6" stroke={stroke} strokeWidth="1.65" strokeLinecap="round" />
    </SvgFrame>
  );
}

export function IconPerson() {
  return (
    <SvgFrame>
      <circle cx="12" cy="8" r="3.2" stroke={stroke} strokeWidth="1.65" />
      <path
        d="M6 20v-1a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v1"
        stroke={stroke}
        strokeWidth="1.65"
        strokeLinecap="round"
      />
    </SvgFrame>
  );
}

export function IconMail() {
  return (
    <SvgFrame>
      <rect x="3" y="5" width="18" height="14" rx="2" stroke={stroke} strokeWidth="1.65" />
      <path d="m3 7 9 6 9-6" stroke={stroke} strokeWidth="1.65" strokeLinecap="round" strokeLinejoin="round" />
    </SvgFrame>
  );
}

export function IconMailConfirm() {
  return (
    <SvgFrame>
      <rect x="3" y="5" width="18" height="14" rx="2" stroke={stroke} strokeWidth="1.65" />
      <path d="m3 7 9 6 9-6" stroke={stroke} strokeWidth="1.65" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8 17h8" stroke={stroke} strokeWidth="1.65" strokeLinecap="round" />
    </SvgFrame>
  );
}

export function IconClipboard() {
  return (
    <SvgFrame>
      <path
        d="M9 4h6a1 1 0 0 1 1 1v1h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h2V5a1 1 0 0 1 1-1z"
        stroke={stroke}
        strokeWidth="1.65"
        strokeLinejoin="round"
      />
      <path d="M9 8h6" stroke={stroke} strokeWidth="1.65" strokeLinecap="round" />
    </SvgFrame>
  );
}
